export const SET_ROLE = 'SET_ROLE'
export const SET_PATH = 'SET_PATH'
export const SET_ACTIVE = 'SET_ACTIVE'
export const SET_STATUS = 'SET_STATUS'
export const SET_CATEGORY = 'SET_CATEGORY'
export const SET_NAME = 'SET_NAME'
export const SET_TYPE = 'SET_TYPE'
export const SET_ROOT = 'SET_ROOT'
